(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rpp-bundles"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rpp="bundles"]').forEach(root=>{
  const track=root.querySelector('[data-track]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
  const step=()=>{const c=track.querySelector('.rpp-bcard');return c?c.getBoundingClientRect().width+20:300;};
  const edges=()=>{prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>track.scrollWidth-4;};
  prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  track.addEventListener('scroll',edges,{passive:true});window.addEventListener('resize',edges);
  if(window.matchMedia('(max-width:640px)').matches){const hot=track.querySelector('.rpp-hero-b');if(hot)track.scrollLeft=hot.offsetLeft-18;}
  edges();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rpp-calculator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rpp="calculator"]').forEach(root=>{
  const box=root.querySelector('.rpp-calc-box'),input=root.querySelector('[data-cars]'),src=root.querySelector('[data-variants]');
  const PER=parseInt(box.dataset.per)||3,PURL=box.dataset.url||'#',q=s=>root.querySelector(s),gbp=c=>'£'+(c/100).toFixed(2);
  // variants: quantity option values must start with a number ("1 stand", "2 stands"...). Any other option is treated as colour.
  const variants=src?JSON.parse(src.textContent):[];
  const rows=variants.map(v=>{const opts=[v.option1,v.option2,v.option3].filter(Boolean);let n=null,colour='';
    opts.forEach(o=>{const m=/^\s*(\d+)\s*stand/i.exec(o);if(m)n=parseInt(m[1]);else colour=o;});
    return n?{n,colour,id:v.id,price:v.price,available:v.available!==false}:null;}).filter(Boolean);
  const colours=[...new Set(rows.map(r=>r.colour).filter(Boolean))];let colour=colours[0]||'';
  const cw=q('[data-colours]');
  if(colours.length>1){cw.classList.remove('rpp-hidden');
    const hex={white:'#ffffff',grey:'#8B8FA0',gray:'#8B8FA0',blue:'#2438E0',black:'#15151A'};
    cw.innerHTML=colours.map((c,i)=>`<button type="button" class="rpp-sw" style="background:${hex[c.toLowerCase()]||c}" data-c="${c}" aria-label="${c}" aria-pressed="${i===0}"></button>`).join('')+`<span class="rpp-sw-name">${colour}</span>`;
    cw.querySelectorAll('.rpp-sw').forEach(b=>b.addEventListener('click',()=>{cw.querySelectorAll('.rpp-sw').forEach(s=>s.setAttribute('aria-pressed','false'));b.setAttribute('aria-pressed','true');colour=b.dataset.c;cw.querySelector('.rpp-sw-name').textContent=colour;calc();}));}
  const maxN=rows.length?Math.max(...rows.map(r=>r.n)):0;
  const find=n=>rows.find(r=>r.n===n&&r.colour===colour)||rows.find(r=>r.n===n);
  function calc(){
    const cars=Math.max(1,Math.min(99,parseInt(input.value)||1));let n=Math.ceil(cars/PER);
    q('[data-stands]').textContent=n;q('[data-holds]').textContent=n*PER;
    if(!rows.length)return;
    const capped=n>maxN;if(capped)n=maxN;
    const v=find(n),one=find(1);
    if(!v)return;
    const alone=one?one.price*n:v.price,pct=one&&n>1?Math.round((1-v.price/alone)*100):0;
    q('[data-pct]').textContent=pct+'%';q('.rpp-stat.rpp-save').style.visibility=n>1?'visible':'hidden';
    q('[data-price]').textContent=gbp(v.price);q('[data-was]').textContent=n>1&&one?gbp(alone):'';
    q('[data-note]').textContent=capped?('for '+n+' stands (our biggest row — email us for more)'):(n>1?'for '+n+' stands bought together':'for one stand');
    const cta=q('[data-cta]');cta.textContent='Buy '+n+(n>1?' stands':' stand');cta.href=PURL+'?variant='+v.id;
  }
  input.addEventListener('input',calc);
  ['focus','input'].forEach(e=>input.addEventListener(e,()=>box.classList.add('rpp-touched')));
  input.addEventListener('focus',()=>input.select());
  calc();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rpp-hero-build"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rpp="hero"]').forEach(root=>{
  const rig=root.querySelector('[data-rig]'),btn=root.querySelector('[data-replay]');
  if(!rig||!btn)return;
  btn.addEventListener('click',()=>{rig.classList.remove('rpp-play');rig.getBoundingClientRect();requestAnimationFrame(()=>rig.classList.add('rpp-play'));});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rpp-products-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rpp="products"]').forEach(root=>{
  const track=root.querySelector('[data-track]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
  const chips=[...root.querySelectorAll('.rpp-chip')],sortSel=root.querySelector('[data-sort]'),countEl=root.querySelector('[data-count]'),empty=root.querySelector('[data-empty]');
  const step=()=>{const c=track.querySelector('.rpp-card:not(.rpp-hidden)');return c?c.getBoundingClientRect().width+22:300;};
  const edges=()=>{prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>track.scrollWidth-4;};
  prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  track.addEventListener('scroll',edges,{passive:true});window.addEventListener('resize',edges);
  let filter='all';
  function apply(){
    const cards=[...track.children];let n=0;
    cards.forEach(c=>{const show=filter==='all'||(','+c.dataset.cat+',').includes(','+filter+',');c.classList.toggle('rpp-hidden',!show);if(show)n++;});
    if(sortSel.value!=='feat'){cards.sort((a,b)=>{const d=parseFloat(a.dataset.price)-parseFloat(b.dataset.price);return sortSel.value==='asc'?d:-d;}).forEach(c=>track.appendChild(c));}
    countEl.textContent=n+(n===1?' product':' products');empty.classList.toggle('rpp-hidden',n>0);
    track.scrollTo({left:0});edges();
  }
  chips.forEach(ch=>ch.addEventListener('click',()=>{chips.forEach(c=>c.setAttribute('aria-pressed','false'));ch.setAttribute('aria-pressed','true');filter=ch.dataset.f;apply();}));
  sortSel.addEventListener('change',apply);
  root.querySelectorAll('[data-swatches]').forEach(g=>{const label=g.querySelector('.rpp-sw-name');g.querySelectorAll('.rpp-sw').forEach(sw=>sw.addEventListener('click',e=>{e.preventDefault();g.querySelectorAll('.rpp-sw').forEach(s=>s.setAttribute('aria-pressed','false'));sw.setAttribute('aria-pressed','true');label.textContent=sw.dataset.c;}));});
  apply();
});

  } catch(e) { console.error(e); }
})();
})();
